import { render, staticRenderFns } from "./MunicipalityDetail.vue?vue&type=template&id=40409c3a&scoped=true&"
import script from "./MunicipalityDetail.vue?vue&type=script&lang=js&"
export * from "./MunicipalityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40409c3a",
  null
  
)

export default component.exports